// extracted by mini-css-extract-plugin
export default {"container":"styles_container__NtGGw","frameError":"styles_frameError__aOHb+"};